module.exports = __webpack_public_path__ + "img/owner_grey_border.42c8be58.svg";